import { HttpClient } from '../httpClient';
import ProofingRule from '../models/proofingRule';
import { TimesheetProofingDistrictModel } from '../models/timesheetProofingDistrictModel';
import TimesheetProofingDistrictsRequest from '../requests/timesheetProofingDistrictsRequest';
import { DataResponse } from '../responses/baseResponse';
import TimesheetProofingDistrictRequest from '../requests/timesheetProofingDistrictRequest';
import PaginatedResponse from '../responses/paginatedResponse';

const httpClient = new HttpClient();

export const getTimesheetProofingDistricts = async (
  request: TimesheetProofingDistrictsRequest
) => {
  return httpClient.post<PaginatedResponse<TimesheetProofingDistrictModel>>({
    url: `/v1/Proofing/Summary`,
    payload: request,
    requiresToken: true,
  });
};

export const getTimesheetProofingDistrict = async (
  request: TimesheetProofingDistrictRequest
) => {
  return httpClient.post<PaginatedResponse<TimesheetProofingDistrictModel>>({
    url: `/v1/Proofing/District`,
    payload: request,
    requiresToken: true,
  });
};

export const getFlags = async () => {
  return httpClient.get<DataResponse<ProofingRule[]>>({
    url: `/v1/Timesheets/Flags`,
    requiresToken: true,
  });
};

export const batchUpdateTimesheetStatuses = async (timesheetIds: number[], changeAffect?: string) => {
  return httpClient.put<DataResponse<number[]>>({
    url: `/v1/Proofing/BatchApprove`,
    payload: { timesheetIds, changeAffect },
    requiresToken: true,
  });
};